export class ElementLog {
    pk: number;
    created_at: string;
    delayed_to: string;
    portal: string;
    lang: string;
    element: string;
    alias_verification: string;
    status: string;
    response: string;
    extra: object;
    request: string;
    feedback: object;


    constructor(row: Object) {
        this.pk = row['pk'];
        this.created_at = row['created_at'];
        this.delayed_to = row['extra']['delayed_to'];
        this.portal = row['portal'];
        this.lang = row['lang'];
        this.element = row['element'];
        this.alias_verification = row['alias_verification'];
        this.status = row['status'];
        this.response = row['response'];
        this.extra = row['extra'];
        this.request = row['request'];
        this.feedback = row['feedback'];

    }

    public static getHeaders(): Array<string> {
        return [
            'pk',
            'created_at',
            'delayed_to',
            'portal',
            'lang',
            'element',
            'alias_verification',
            'status',
            'response',
            'extra',
            'request',
            'feedback'

        ]
    }
}


// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/elements/model/element-log.ts